/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import { UtrvStatus } from '../../constants/status';
import { EvidenceFile } from '@g17eco/types/file';
import IconButton from '@g17eco/molecules/button/IconButton';

interface ToggleIconProps {
  i: number;
  allowToggle?: boolean;
  saving?: boolean;
  toggleFile: (i: number, file: EvidenceFile) => void;
  file: EvidenceFile;
}

export function ToggleIcon(props: ToggleIconProps) {
  const { i, allowToggle = false, saving = false, toggleFile, file } = props;

  const isDeleted = '_id' in file && file.isDeleted;
  const evidenceTick = isDeleted
    ? 'text-ThemeDangerMedium border-ThemeDangerMedium'
    : 'text-ThemeAccentMedium border-ThemeAccentMedium';
  const status = '_id' in file ? file.status ?? '' : '';

  const canDelete = (!('_id' in file) || file.status === UtrvStatus.Updated);

  if (allowToggle && canDelete) {
    const text = isDeleted ? 'Click to undo remove evidence' : 'Click to remove evidence';
    return (
      <SimpleTooltip className='text-center' text={text}>
        <IconButton
          outline
          icon='fal fa-xmark'
          color='error'
          style={{ cursor: saving ? 'not-allowed' : 'pointer' }}
          className={`utrv-status ${status} ${evidenceTick} border icon-button--size-xs btn-xs me-1`}
          onClick={() => !saving && toggleFile(i, file)}
        />
      </SimpleTooltip>
    );
  }

  return (
    <SimpleTooltip text={'You are not allowed to remove this evidence item'}>
      <IconButton
        disabled
        outline
        icon='fal fa-xmark'
        color='danger'
        style={{ cursor: 'not-allowed' }}
        className={`utrv-status ${status} ${evidenceTick} border icon-button--size-xs btn-xs me-2`}
      />
    </SimpleTooltip>
  );
}
